export default "__VITE_ASSET__DiI1OHBy__"